import LoadMoreView from '@components/orders-sales/common-views/load-more';

interface BuyingOffersCardProps {
  onLoadMore: () => void;
  loading: boolean;
  totalCount: number;
  currentLength: number;
}

const SellingOffersNegotiationPagination: React.FC<BuyingOffersCardProps> = ({
  onLoadMore,
  loading,
  totalCount,
  currentLength,
}) => {
  if (totalCount <= currentLength || loading) {
    return <></>;
  }

  return (
    <LoadMoreView
      onClick={onLoadMore}
      loading={loading}
    />
  );
};

export default SellingOffersNegotiationPagination;
